module.exports = __webpack_public_path__ + "static/media/招财猫.b977034d.png";